import { Component } from '@verndale/core'
import { rovingIndex } from '@verndale/roving-ux'
class Module extends Component {
  setupDefaults() {
    this.dom = {
      $innerContainer: this.el.querySelector('.faq-listing__inner'),
      $panels: this.el.querySelectorAll('.faq-listing__panel'),
      $panelsContainer: this.el.querySelector('.faq-listing__panels-container'),
      $panelsList: this.el.querySelector('.faq-listing__panel'),
      $navContainer: this.el.querySelector('.faq-listing__side-nav'),
      $selectName: this.el.dataset.selectName,
      $selectId: this.el.dataset.selectId,
      $navRole: this.el.dataset.navRole,
      $navAriaLabel: this.el.dataset.navAriaLabel
    }

    this.enableFirstValidTab()
    this.generateSelect()
    this.generateSideNav()
    this.implementRovin()
  }

  enableFirstValidTab() {
    if (this.dom.$panels && this.dom.$panels.length) {
      for(let i = 0; i < this.dom.$panels.length; i++) {
        if (this.dom.$panels[i].innerHTML && this.dom.$panels[i].innerHTML.trim()) {
          this.dom.$panels[i]?.setAttribute('tabindex', 0)
          break
        }
      }
    }
  }

  generateSelect() {
    this.select = document.createElement('select')
    this.select.classList.add('faq-listing__select')
    this.select.setAttribute('name', this.dom.$selectName)
    this.select.setAttribute('id', this.dom.$selectId)
    this.select.innerHTML = Array.from(this.dom.$panels)
      .map((panel) => {
        if (panel.innerHTML && panel.innerHTML.trim()) {
          return `<option value="${panel.id}" class="faq-listing__select-option">${panel.dataset.navTitle}</option>`
        }
      })
      .join('')
    this.select.addEventListener('input', this.handleClick.bind(this))
    this.dom.$innerContainer.insertBefore(this.select, this.dom.$panelsContainer)
  }

  generateSideNav() {
    const ul = document.createElement('ul')
    ul.classList.add('faq-listing__faq-list')
    ul.setAttribute('role', this.dom.$navRole)
    ul.setAttribute('aria-label', this.dom.$navAriaLabel)
    ul.innerHTML = Array.from(this.dom.$panels)
      .map((panel) => {
        if (panel.innerHTML && panel.innerHTML.trim()) {
          return ` <li class="faq-listing__option" data-hash="${panel.dataset.hash}" aria-controls="${panel.id}" aria-label="${panel.dataset.navTitle}">${panel.dataset.navTitle}</li>`
        }
      })
      .join('')
    Array.from(ul.children).forEach((option) =>
      option.addEventListener('click', this.handleClick.bind(this))
    )

    const hash = decodeURI(window.location.hash?.substring(1, window.location.hash?.length)).toLowerCase();

    if (hash) {
      const index = Array.from(ul.children).findIndex(
        (el) =>  el.dataset.hash === hash
      )
      if (index > -1) {
        ul.children[index]?.classList.add('faq-listing__option--active')
        ul.children[index].click();
      } else {
        ul.children[0].classList.add('faq-listing__option--active')
      }
    } else {
      ul.children[0].classList.add('faq-listing__option--active')
    }
    this.dom.$navContainer.append(ul)
  }

  addListeners() {
    window.addEventListener('resize', this.handleResize.bind(this))
  }

  implementRovin() {

    rovingIndex({
      element: this.dom.$navContainer,
      target: '.faq-listing__option'
    })


  }

  handleResize() {
    const selected = this.el.querySelector('.faq-listing__panel[tabindex="0"]')
    this.select.value = selected.id
  }

  handleClick(e) {
    e.target.focus()
    const value = e.target.value ? e.target.value : e.target.getAttribute('aria-controls')
    const navSideOptions = this.el.querySelectorAll('.faq-listing__option')
    this.dom.$panels.forEach((panel) => {
      if (value === panel.id) {
        panel.setAttribute('tabindex', 0)
      } else {
        panel.setAttribute('tabindex', -1)
      }
    })
    navSideOptions.forEach((option) => {
      if (value === option.getAttribute('aria-controls')) {
        option.classList.add('faq-listing__option--active')
      } else {
        option.classList.remove('faq-listing__option--active')
      }
    })
  }
}

export default Module
